import React from "react";
import {useSelector} from "react-redux";

const CartIcon = ({
  cartId
}) => {
  const cartItemsQuantity = useSelector(state => state.cartItemsQuantity)

  return (
    <a className="ml-4 px-0 position-relative"
       href={"/carts/" + cartId + "/edit"}>
      <img src={window.location.origin + `/images/icons/cart.svg`} alt="cart" height="30" width="30"/>
      {
        (cartItemsQuantity && cartItemsQuantity > 0) ? <span className="badge mb-4 cart-badge--position">{cartItemsQuantity}</span> : <React.Fragment></React.Fragment>
      }
    </a>
  );
};

export default CartIcon;